import moment from 'moment-timezone'

moment.locale('de-de')

export default {
  methods: {
    momentDate(date) {
      // TimeZone has to be baked here
      return moment.tz(date, 'Europe/Berlin')
    },
    forceTwoDigits(num) {
      return (num < 10 ? '0' : '') + num
    },
    isToday(checkDate) {
      const today = new Date()
      if (checkDate) {
        return (
          checkDate.getDate() == today.getDate() &&
          checkDate.getMonth() == today.getMonth() &&
          checkDate.getFullYear() == today.getFullYear()
        )
      } else {
        return false
      }
    }
  }
}
